import React, { useEffect } from 'react';
import { NumericTextBox } from "@progress/kendo-react-inputs";

const RelativeDateField = (props) => {

	useEffect(() => {
		const formattedValueField = document.querySelector(".k-formatted-value");
		if (formattedValueField !== undefined && formattedValueField !== null) {
			formattedValueField.addEventListener("keydown", e => {
				if (e.keyCode === 109 || e.keyCode === 189) {
					e.stopPropagation()
					e.preventDefault();
				}
			});
		}
	}, [props.visible]);

	const values = props.value ? props.value.split("_") : ["Today", "+", "0", "Days"];

	function handleSignChange(newSign) {
		const newValue = [...values];
		newValue[1] = newSign;
		const value = newValue.join("_");
		props.onChangeSign({
			target: {
				name: "defaultDate",
				value: value
			}
		})
	}

	function handleValueChange(e) {
		const { value: newNumber } = e.target;
		const newValue = [...values];
		newValue[2] = newNumber;
		const value = newValue.join("_");
		props.onChangeValue({
			target: {
				name: "defaultDate",
				value: value
			}
		})
	}

	function handleTypeChange(newType) {
		const newValue = [...values];
		newValue[3] = newType;
		const value = newValue.join("_");
		props.onChangeType({
			target: {
				name: "defaultDate",
				value: value
			}
		})
	}

	if (!props.visible) {
		return null;
	}

	return (
		<div className="mt-1 d-flex align-items-center">
			<span className='px-1'>{values[0]}</span>

			<div className="btn-group" role="group">
				<button type="button" className={`${values[1] === '+' ? 'btn-primary' : 'btn-secondary'} btn`} onClick={() => handleSignChange('+')}>+</button>
				<button type="button" className={`${values[1] === '-' ? 'btn-primary' : 'btn-secondary'} btn`} onClick={() => handleSignChange('-')}>-</button>
			</div>

			<div className='flex-grow-1 numeric-textbox mx-2'>
				<NumericTextBox
					name="value"
					className={'form-control flex-grow-1' + ((values[2] === "0" || !(values[2])) ? " date-picker-hide-arrows" : "")}
					id="inlineFormInputGroupUsername2"
					placeholder="Type a number"
					type="number"
					min={0}
					value={values[2]}
					onChange={handleValueChange}>
				</NumericTextBox>
			</div>

			<div className="btn-group" role="group">

			</div>

			<div className="btn-group" role="group">
				<button type="button" className={`${values[3] === 'Days' ? 'btn-primary' : 'btn-secondary'} btn`} onClick={() => handleTypeChange("Days")}>Day{props.value > 1 && "s"}</button>
				<button type="button" className={`${values[3] === 'Weeks' ? 'btn-primary' : 'btn-secondary'} btn`} onClick={() => handleTypeChange("Weeks")}>Week{props.value > 1 && "s"}</button>
				<button type="button" className={`${values[3] === 'Years' ? 'btn-primary' : 'btn-secondary'} btn`} onClick={() => handleTypeChange("Years")}>Year{props.value > 1 && "s"}</button>
			</div>
		</div>
	);
};

export default RelativeDateField;